import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCurrencyDollar: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="currency-dollar, money"><path d="M12 23.5V0.5" stroke="currentColor" strokeWidth="1.5"/><path d="M5.75 17.2087C7.83333 21.8645 18.25 21.5118 18.25 16.5884C18.25 10.8535 6.27083 13.806 6.27083 7.45373C6.27083 2.98717 14.3217 2.23707 17.5 5.55051" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCurrencyDollar;
